import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Paper from '@material-ui/core/Paper'

import { MyBookingItem } from '../../common'

import * as Constants from '../../../helpers/Constants'
import * as Styles from './styles'
import * as Strings from './strings'
import * as configActions from '../../../actions/Config'

class MyBookingsHandler extends Component {
  requestUnbookTime(deleteBooking) {
    const { config } = this.props

    this.props.showAlert(
      Strings.default.REQUEST_UNBOOK_TIME[config.language],
      Strings.default.REQUEST_UNBOOK_TIME_INFO[config.language],
      Constants.TWO_BUTTONS,
      {
        title: Strings.default.NO[config.language],
        onPress: () => {}
      },
      {
        title: Strings.default.YES[config.language],
        onPress: () => deleteBooking()
      }
    )
  }

  getMyBookingsHandler() {
    const { config, items } = this.props

    if (items.length === 0) {
      return <p>{Strings.default.NO_BOOKINGS[config.language]}</p>
    }

    return items.map(item => {
      return (
        <MyBookingItem
          key={item.id}
          date={item.date}
          time={item.time}
          title={item.title}
          buttonTitle={Strings.default.UNBOOK[config.language]}
          onClick={() => this.requestUnbookTime(() => item.deleteBooking())}
          loading={item.isDeleting}
        />
      )
    })
  }

  render() {
    const { contentContainerStyle } = Styles.default
    const { user, title } = this.props

    return (
      <Paper
        style={{
          ...contentContainerStyle,
          marginTop: user.offlineModeSignedIn ? 160 : 120
        }}
      >
        <h2 style={{ textAlign: 'center' }}>{title}</h2>
        {this.getMyBookingsHandler()}
      </Paper>
    )
  }
}

function mapStateToProps({ config, user }) {
  return { config, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyBookingsHandler)



// WEBPACK FOOTER //
// ./src/components/containers/MyBookingsHandler/index.js